import React, { useState } from "react";
import { Button, Card, Col, Form, Nav, Row } from "react-bootstrap";
import Logo from "../assets/vk.png";
import Reg from "../assets/reg.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../academyStore/slices/AuthSlice";

const Login = () => {
  let navigate = useNavigate();
  const [user, setUser] = useState({
    username: "",
    password: "",
  });
  const [validated, setValidated] = useState(false);
  const isLogged = useSelector((state) => state.user.isLoggedIn);
  const errMsg = useSelector((state) => state.user.error);
  const dispatch = useDispatch();
  const loginHandler = (e) => {
    e.preventDefault();
    setValidated(true);
    dispatch(loginUser(user))
      .unwrap()
      .then(() => {
        navigate("/dashboard");
      });
  };
  return (
    <section className="login position-relative">
      <Row className="mx-0 py-5">
        <Col
          className="position-absolute top-50 start-50 translate-middle h-100 my-5"
          md={8}
        >
          <Row>
            <Col md={6} className="shadow-lg bg-white rounded-start mx-auto">
              <h3 className="px-3 pt-4 pb-3 text-center">Login</h3>
              <h6 className="text-danger">{errMsg}</h6>
              <Form
                className="p-3"
                noValidate
                validated={validated}
                onSubmit={loginHandler}
              >
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="username">Email Id</Form.Label>
                  <Form.Control
                    placeholder="Enter email id "
                    name="username"
                    required
                    id="username"
                    value={user.username}
                    onChange={(e) =>
                      setUser({ ...user, username: e.target.value })
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter your email / phone
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Label htmlFor="password">Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    required
                    name="password"
                    id="password"
                    value={user.password}
                    onChange={(e) =>
                      setUser({ ...user, password: e.target.value })
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter your passord
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 float-end">
                  <Nav className="">
                    <Nav.Link href="/#" className="p-0">
                      Forgot password?
                    </Nav.Link>
                  </Nav>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Button variant="danger" className="w-100" type="submit">
                    Login Now
                  </Button>
                </Form.Group>
              </Form>
            </Col>
            {/* <Col md={6} className="shadow-lg bg-white rounded-end">
              <h4 className="px-4 pt-5 pb-2">
                <span className="border-bottom">New to</span>{" "}
                <img src={Logo} alt="" />
              </h4>
              <ul className="px-4">
                <li className="">
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; One click apply using vk profiles.
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Take MCQ tests and get more confidence.
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Get relevant job recommendations.
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Showcase profile to top companies and consultants.
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Know application status on applied jobs.
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Refer your friends and Highlight your application.
                </li>
              </ul>
              <Button
                variant="outline-danger"
                className="px-5 ms-5"
                onClick={() => navigate("/signup")}
              >
                Register for Free
              </Button>
              <span className="reg float-end">
                <img src={Reg} alt="" />
              </span>
            </Col> */}
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default Login;
